export function calculateUploadProgress(
  totalFileSize: number,
  remainingFileSize: number,
): number | undefined {
  const progress = Math.floor(100 - (remainingFileSize / totalFileSize) * 100);
  if (isNaN(progress)) return undefined;
  else return progress;
}
